<smt-modal [(isActive)]="confirmModalActive"  [allowDropDownOverflow]="true" [disableFooter]="false" [disableHeader]="true"
    (acceptEvent)="confirmYes(rowIdToDelete)" (rejectEvent)="confirmModalActive = false"
    acceptText="Yes" acceptCssClass="button primary" rejectText="No" rejectCssClass="button cancel">
   <div role="body">
    The removal of this job title will cause your staffing grid to be redrawn.  Do you want to continue?
   </div>
</smt-modal>
<ng-container>
    <section>
        <div>
            <h3>Basic Information</h3>
            <div class="form-group">
                <label>Facility</label>
                <select required name="costCenterFacility" id="facilityDropdown" class="body-dropdown" [disabled]="readOnly || hasWorkflowData" [(ngModel)]="selectedFacility">
                    <option *ngFor="let facility of facilities" [ngValue]="facility">
                        {{ facility.name }}
                    </option>
                </select>
            </div>
            <div class="form-group">
                <label>Name</label>
                <input type="text" required name="costCenterName" [readonly]="readOnly" [(ngModel)]="selectedName">
            </div>
            <div class="form-group">
                <label>Number</label>
                <input maxlength="20" type="text" required name="costCenterNumber" [readonly]="readOnly" [(ngModel)]="selectedNumber">
            </div>
            <div class="form-group">
                <label>Status:</label>
                <select name="costCenterStatus" id="statusDropdown"
                    [disabled]="!canActivateCostCenter || readOnly"
                    [(ngModel)]="selectedStatus">
                    <option *ngFor="let status of statuses" [ngValue]="status.StatusId">
                        {{ status.StatusName }}
                    </option>
                </select>
            </div>

        </div>
    </section>
    <section>
        <div>
            <div>
                <h3>Job Titles</h3>
                <span class="inline warning" *ngIf="missingJobTitles"><span class="icon-warning2"></span> Please add Job Titles</span>
                <expandable-list-ordered infoLabel="Job Title" [groupArray]="['Variable','Fixed']" (orderUpdated)="orderUpdated($event)"  (rowsChange)="jobChangeEvent($event)" acceptText="Add Job Title" (removeItemCallBack)="markConfirmModalActive($event)"
                 [columns]="jobTitleColumns"   [(rows)]="jobTitleRows" [skipRowUpdate]="!isNewCostCenter && isFutureShiftBlockAvailable" [includeBlank]="true" [defaultToBlank]="true"  [dropdownItems]="jobTitles"
                    [readOnly]="readOnly">
                </expandable-list-ordered>
            </div>
        </div>
    </section>
    <section>
        <div>
            <h3>Measures</h3>
            <expandable-list-ordered infoLabel="Measure" (rowsChange)="staffingChangeEvent($event)" acceptText="Add Measure" (orderUpdated)="orderUpdated($event)"
                [columns]="measureColumns" [(rows)]="measureRows" [includeBlank]="true" [defaultToBlank]="true" [dropdownItems]="measures"
                 [maxRows]="maximumAllowedMeasures" (limitedRowsReached) ="limitedRowsWarningMessage($event)" [readOnly]="readOnly">
            </expandable-list-ordered>
        </div>
    </section>
    <section>
        <div>
            <h3>Reasons for Variance</h3>
            <span class="inline warning" *ngIf="missingVarianceReasons"><span class="icon-warning2"></span> Please add Reasons for Variance</span>
            <expandable-list-ordered infoLabel="Reason for Variance" (orderUpdated)="orderUpdated($event)" (rowsChange)="reasonsChangeEvent($event)" acceptText="Add Reason for Variance"
             [columns]="varianceColumns" [(rows)]="varianceRows" [dropdownItems]="variances" [includeBlank]="true" [defaultToBlank]="true" [readOnly]="readOnly">
            </expandable-list-ordered>
        </div>
    </section>
    <section>
        <div>
            <h3>Users</h3>
            <expandable-list-ordered (rowsChange)="usersChangeEvent($event)" acceptText="Add User" [columns]="userColumns"
                [(rows)]="userRows" [dropdownItems]="userDropdownList" [includeBlank]="true" [defaultToBlank]="true" [readOnly]="readOnly">
            </expandable-list-ordered>
        </div>
    </section>
</ng-container>
